var businessPerson = "https://shopfront-cdn.tekoapis.com/static/22eb9c4eaaae04c3.svg";

export { businessPerson as default };
